import React from "react";
import partnersData from "../data/partnersData";
import { useTranslation } from "react-i18next";

export default function Partners() {
    const { t } = useTranslation();
    return (
        <div className="bg-gray-100 p-6">
            <div className="max-w-[84rem] f-col flex items-center gap-[30px] mx-auto">
                <p className="text-gray-600 mb-4 text-lg font-medium leading-[1.1]">
                    {t("Partners with Dubai’s leading developers")}
                </p>
                <div className="dir-ltr relative overflow-hidden w-full">
                    <div className="dir-ltr flex animate-marquee">
                        {partnersData.concat(partnersData).map((logo, index) => (
                            <div
                                key={index}
                                className="flex justify-center items-center mx-[2rem]" 
                            >
                                <img
                                    src={logo.image}
                                    alt={`logo-${index}`}
                                    className="w-auto h-auto max-w-[100px] max-h-[100px]" 
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
